import { routesList } from "./Routes"
import { createBrowserRouter } from "react-router-dom"
import GlobalScene from "@scene/GlobalScene"

const EngineRouter = () => {
  const browserRoutes = Object.keys(routesList).map(route => {
    return { path: routesList[route], element: <GlobalScene scene={route} /> }
  })

  return createBrowserRouter(browserRoutes)
}

export default EngineRouter